import { render, staticRenderFns } from "./token.vue?vue&type=template&id=227ec266&"
import script from "./token.vue?vue&type=script&lang=js&"
export * from "./token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports